import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume9 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="w-[8.5in] mx-auto my-5 bg-white p-5 shadow-md" ref={resumeRef}>
        <div className="text-center pb-5 border-b-3 border-[#333] relative">
          <h1 className="text-4xl font-bold">
            {ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}
          </h1>
          <p className="mt-2">
            {ResumeStore?.resumeBuilder.personalDetails.address}<br />
            {ResumeStore?.resumeBuilder.personalDetails.email} | {ResumeStore?.resumeBuilder.personalDetails.phone}
          </p>
          <img
            className="absolute top-0 right-20 w-28 h-28 rounded-full object-cover"
            src={
              ResumeStore?.resumeBuilder?.profile ??
              "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"
            }
            alt="Profile Picture"
          />
        </div>
        <div className="flex mt-5">
          <div className="w-1/2 pr-4">
            <div className="mb-5">
              <h2 className="text-2xl font-bold border-b-2 border-[#333] pb-1">PROFESSIONAL SUMMARY</h2>
              <p className="mt-2">{ResumeStore?.resumeBuilder?.profileSummary}</p>
            </div>
            <div className="mb-5">
              <h2 className="text-2xl font-bold border-b-2 border-[#333] pb-1">WORK HISTORY</h2>
              {ResumeStore?.resumeBuilder?.employementHistory?.map((job, index) => (
                <div key={index} className="mb-5">
                  <h3 className="text-lg font-bold">
                    {job.jobTitle}<br />
                    <span className="italic">{job.startDate} – {job.endDate}</span>
                  </h3>
                  <ul className="list-disc pl-5 mt-2">
                    {job.description?.split('\n')?.map((desc, index) => (
                      <li key={index}>{desc}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="mb-5">
              <h2 className="text-2xl font-bold border-b-2 border-[#333] pb-1">SKILLS</h2>
              <ul className="list-disc pl-5 mt-2">
                {ResumeStore?.resumeBuilder?.skills?.map((skill, index) => (
                  <li key={index}>{skill}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="w-1/2 pl-4">
            <div className="mb-5">
              <h2 className="text-2xl font-bold border-b-2 border-[#333] pb-1">EDUCATION</h2>
              {ResumeStore?.resumeBuilder?.education?.map((edu, index) => (
                <p key={index} className="mt-2">
                  {edu.degree}<br />
                  ({edu.startDate} – {edu.endDate})<br />
                  {edu.school}<br />
                  {edu.city}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ));
};

export default Resume9;
